import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60a521fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=60a521fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a521fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a521fc')) {
      api.createRecord('60a521fc', component.options)
    } else {
      api.reload('60a521fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=60a521fc&scoped=true", function () {
      api.rerender('60a521fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/servesRests/index.vue"
export default component.exports